module.exports = __webpack_public_path__ + "img/timer_red.d63c5bf9.svg";